export const isValidEmail = (email: string) => /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9-]+)*$/.test(email)
export const isValidPassword = (password: string) => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z~!@#$%^&*()_+`<>,.'";:|?/[\]{}\d]{8,}$/.test(password)
export const firstLetterLowercase = (string: string) => {
    const firstLetter = string.charAt(0).toLowerCase()
    const rest = string.slice(1)

    return `${firstLetter}${rest}`
}
